import { AfterViewInit, Component, ElementRef, OnInit, Optional, ViewChild } from '@angular/core';
import { NbDialogRef, NbMenuService, NbDialogService } from '@nebular/theme';
import { HomeInputGridComponent } from '../home-input-grid/home-input-grid.component';
import { BloglistLayoutEnum, RendererType, TestimonialLayoutEnum } from '@urbannex/storethemes';
import { BloglistInputDialogComponent } from './bloglist-input-dialog/bloglist-input-dialog.component';

@Component({
  selector: 'kve-home-input-bloglist',
  templateUrl: './home-input-bloglist.component.html',
  styleUrls: ['./home-input-bloglist.component.scss']
})
export class HomeInputBloglistComponent implements OnInit, AfterViewInit{
  activeInputMenuItem:string;
  title:string;
  collapsed:boolean = true;

  @ViewChild('expandable',{read:ElementRef}) expandable:ElementRef<HTMLElement>

  constructor(
    @Optional() protected ref: NbDialogRef<HomeInputGridComponent>,
    private menuService:NbMenuService,
    private el:ElementRef<HTMLElement>,
    private dialogService: NbDialogService
    ) { }

  ngOnInit(): void {
    this.menuService.onItemClick().subscribe(menuBag =>{
      let selectedItem = menuBag.item;
      if(selectedItem != undefined){
        this.activeInputMenuItem = selectedItem.title;
      }
    })
  }

  ngAfterViewInit():void{
    const overlayPane = this.el.nativeElement.parentElement.parentElement;
    const overlayWrapper = this.el.nativeElement.parentElement.parentElement.parentElement;
    setTimeout(() => {
      overlayWrapper.style.left ="0px";
      overlayWrapper.style.justifyContent = "flex-end";
      overlayWrapper.style.right = "16px";
      //overlayPane.style.width = "256px";
      overlayPane.style.marginRight = "16px";
      overlayPane.style.marginTop = "18px";
      overlayPane.style.display = "block";
    }, 1);


    //return el.parentElement.parentElement.parentElement.parentElement;
  }

  toggleContainer(){
    this.expandable.nativeElement.classList.toggle("collapsed");
  }

  getLayoutClass(numberOfCells:number):BloglistLayoutEnum{
    switch (numberOfCells) {
      case 1:
        return BloglistLayoutEnum.LAYOUT_1        
        break;
      case 2:
        return BloglistLayoutEnum.LAYOUT_2
        break;
      case 3:
        return BloglistLayoutEnum.LAYOUT_3
        break;
      case 4:
        return BloglistLayoutEnum.LAYOUT_4
        break;
      default:
        return BloglistLayoutEnum.LAYOUT_1
        break;
    }

  }

  createGrid(numberOfElements){
    const layoutClass = this.getLayoutClass(numberOfElements);
    console.log(layoutClass);
    this.dialogService.open(BloglistInputDialogComponent, {
      context:{
        rendererType:RendererType.BLOGLIST,
        layoutClass:layoutClass,
        title:"Adding new blog list section with layout: "+layoutClass
      }
    }).onClose.subscribe(() => {
      console.log("closing")
    })
    this.ref.close();
  }

  close(e){
    this.ref.close();
  }

}
